export const en = {
  navigation: {
    map: "Map",
    guessr: "Guessr",
  },
  home: {
    filters: "Filters",
    general: "General",
    filterItems: {
      FAST_TRAVEL: "Fast Travel",
      NEXT_CS: "Next Competition",
      GUESSR: "SSO Guessr Locations",
    },
    coordinates: "X: {x}, Y: {y}",
  },
  guessr: {
    title: "SSO Guessr",
    loading: "Loading...",
    buttons: {
      guess: "Guess",
      next: "Next",
      again: "Play Again",
      leaveConfirm: "Game is in progress. Are you sure you want to leave?",
    },
    toasts: {
      zeroPoints: "😥 Not quite... 0 points",
      goodPoints: "👍 Not bad! You scored {points} points!",
      perfectPoints: "💕 PERFECT! {points} POINTS!",
      fetchError: "Error fetching data: {message}",
    },
    alt: {
      locationPhoto: "Location photo, guess where it was taken",
      fullscreenPreview: "Fullscreen photo preview",
      clickToEnlarge: "Click photo to enlarge",
      tapToEnlarge: "Tap photo to enlarge",
    },
    result: {
      perfect: [
        "Congratulations! You are a true location master!",
        "Perfection! Your knowledge of Jorvik is impressive.",
        "Exceptional memory! You have a great eye for detail.",
        "Bravo! You identified every location flawlessly!",
      ],
      almostPerfect: [
        "Fantastic! You are almost a master at recognizing locations.",
        "Practically perfect! Just a few details to improve.",
        "Impressive! Only minor tweaks separate you from perfection.",
        "Great! You are at a very high level.",
        "Not much missing for a perfect score!",
      ],
      great: [
        "Great job! You are almost an expert.",
        "Very close! A few minor adjustments and you'll be at the top.",
        "Feeling confident? One more moment and you'll be the best!",
        "Very good! Only a few details left to refine.",
      ],
      good: [
        "Not bad, but you can do better!",
        "Close, but still some work ahead of you.",
        "A few steps forward and you'll be a master!",
        "You are starting to get going. Continue in this direction!",
      ],
      sad: [
        "That didn't go very well. Try again!",
        "Look around Jorvik and come back enlightened...",
        "Don't you get lost in your own house with such a memory?",
        "Oh my, that's not the best score. Maybe next time will be better?",
        "Don't get discouraged! Every attempt brings you closer to the goal.",
        "Looks like you need a bit more practice.",
        "Don't worry, even the best started from zero!",
      ],
    },
    footer: {
      author: "Łukasz Skabowski",
      source: "Source Code",
    },
  },
  fastTravel: {
    HERMITS_COTTAGE: "Hermit's Cottage",
    DRUID_PADDOCK: "Druid Paddock",
    DUNDULL: "Dundull",
    SILVERGLADE_MANOR: "Silverglade Manor",
    JASPERS_PUMPKIN_FARM: "Jasper's Pumpkin Farm",
    STORMGARDEN: "Stormgarden",
    SOUTH_HOOF_FARM: "South Hoof Farm",
    SUNFIELD_FARM: "Sunfield Farm",
    STEVES_FARM: "Steve's Farm",
    FORT_PINTA: "Fort Pinta",
    BIRKS_GRANGE: "Birk's Grange",
    JARLAHEIM: "Jarlaheim",
    VALEDALE_LAKE: "Valedale Lake",
    SPYMASTERS_HIDEOUT: "Spymaster's hideout",
    CRESCENT_MOON_VILLAGE: "Crescent Moon Village",
    ICENGATE: "Icengate",
    SILVERGLADE_VILLAGE: "Silverglade Village",
    REDWOOD_POINT: "Redwood Point",
    STARSHINE_RANCH: "Starshine Ranch",
    MOORLAND_STABLES: "Moorland Stables",
    NEW_HILLCREST_STABLES: "New Hillcrest Stables",
    GOLDENLEAF_STABLES: "Goldenleaf Stables",
    MARLEYS_VINTAGE_BARN: "Marley's Vintage Barn",
    BARONESS_RACETRACK: "Baroness' Racetrack",
    RIDING_ARENA: "Riding Arena",
    FIRGROVE_VILLAGE: "Firgrove Village",
    TAILTOP_VILLAGE: "Tailtop Village",
    VALEDALE_VILLAGE: "Valedale Village",
    PADDOCK_ISLAND: "Paddock Island",
    NILMERS_HIGHLAND: "Nilmer's Highland",
    CAPE_WEST_FISHING_VILLAGE: "Cape West Fishing Village",
    WOLF_HALL_INN: "Wolf Hall Inn",
    THE_FORGOTTEN_FIELDS: "The Forgotten Fields",
    FORT_PINTA_BEACH: "Fort Pinta Beach",
    MEDIEVAL_CAMP: "Medieval Camp",
    NIC_STONEGROUNDS_CAMP: "Nic Stoneground's Camp",
    THE_EVERWIND_FIELDS: "The Everwind Fields",
  },
  championships: {
    moorland: "Moorland",
    pinta: "Fort Pinta",
    silversong: "Silversong Pony Championship",
    baron: "Baroness' Championship",
    gold: "Goldenhills",
    jorvik: "Jorvik Stables",
    silver: "Silverglade Village",
    grove: "Firgrove",
    gran: "New Hillcrest",
    valedale: "Valedale",
  },
  time: {
    minutesSeconds: "in {minutes}min {seconds}s",
    seconds: "in {seconds}s",
  },
};
